module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_IMAGE_1.a26f6096.png";